import { ReactNode } from "react";

import { Container } from "@mui/material";

import { Background } from "@baseComponents/Background";
import { Menu } from "@components/menu";
import { PageMetadata, PageMetadataProps } from "@components/PageMetadata";

import Footer from "../footer";

import { MDXStyles } from "./styles.styled";

interface PolicyLayoutProps extends PageMetadataProps {
  children?: ReactNode;
}

function PolicyLayoutBody({ children, title, description }: PolicyLayoutProps) {
  return (
    <>
      <PageMetadata title={title} description={description} />

      <Background />

      <Menu />

      <Container maxWidth="desktopXl">
        <MDXStyles>{children}</MDXStyles>
      </Container>

      <Footer />
    </>
  );
}

export const PolicyLayout = ({ children, ...rest }: PolicyLayoutProps) => {
  return <PolicyLayoutBody {...rest}>{children}</PolicyLayoutBody>;
};
